<script>
   import PayoutListModal from './PayoutListModal.vue';

   import formatters from '@/mixins/formatters.js';

   export default {
      name: 'PayoutListIndex',
      components: { PayoutListModal },
      mixins: { formatters },
      data() {
         return {
            searchItem: '',
            listOfFacilities: {
               data: [],
               current_page: 1,
               per_page: 10,
               total: 10,
            },
         }
      },
      async mounted() {

         // created at = when the facility transfer to arbitrage ,when the facility insert arbitrage setting
         // last updated = get the latest created payout 
         await this.searchFacility({
            page: 1,
            per_page: this.listOfFacilities.per_page,
            search: this.searchItem
         });
      },
      methods: {
         async paginate(page) {
            var filter = {
               page: page,
               per_page: this.listOfFacilities.per_page,
               search: this.searchItem
            };
            await this.searchFacility(filter);
         },
         async performSearch() {
            await this.searchFacility({
               page: 1,
               per_page: this.listOfFacilities.per_page,
               search: this.searchItem
            });
         },
         async searchFacility(data) {
            const result = await this.$lionheart.get('/v2/facility-arbitrage-list', { params: data });
            this.listOfFacilities = result.data.data;
         },
      }
   }
</script>

<template>
   <div>
      <div class="d-flex justify-content-between px-3">
         <form class="form-inline" @submit="searchFacility">
            <div class="form-group">
               <label for="listOfFacilities" class="mr-2 font-weight-bold text-primary">
                  {{ $t('admin_page.payout_index.list_of_facilities_text') }}
               </label>
               <input
                  v-model="searchItem"
                  v-debounce:500ms="performSearch"
                  type="text"
                  class="form-control"
                  id="listOfFacilities"
                  :placeholder="$t('admin_page.payout_index.search_text')"
               />
            </div>
         </form>

         <div class="d-flex">
            <router-link
               class="btn btn-primary btn-md text-sm mt-2 mr-2"
               role="button"
               :to="{ name: 'checkin-admin-payout-email-log' }"
            >
               <!-- {{ $t('admin_page.payout_index.batch_button') }} -->
                 Email Log
            </router-link>
            <router-link
               class="btn btn-success btn-md text-sm mt-2"
               role="button"
               :to="{ name: 'checkin-admin-payout-batch-arbitrage' }"
            >
               <!-- {{ $t('admin_page.payout_index.batch_button') }} -->
                 Batch
            </router-link>
         </div>

      </div>

      <div class="d-flex justify-content-end px-3">
         
      </div>
      <!-- table -->
      <div class="col-12 mt-3">
         <div class="table-responsive table-bordered visitors-table">
            <table id="dataTable" cellspacing="0" class="table table-bordered visitors-table mb-0" width="100%">
               <thead>
                     <tr>
                        <th class="col-name">{{ $t('admin_page.payout_index.name_table_column') }}</th>
                        <th class="col-actions">{{ $t('admin_page.payout_index.action_table_column') }}</th>
                        <th class="col-created">{{ $t('admin_page.payout_index.created_table_column') }}</th>
                        <th class="col-updated">{{ $t('admin_page.payout_index.last_update_table_column') }}</th>
                        <th class="col-payout">{{ $t('admin_page.payout_index.latest_payout_date_table_column') }}</th>
                        <th class="col-email">Latest Email Sent</th>
                     </tr>
               </thead>

               <tbody>
                  <tr v-for="(value, key) in listOfFacilities.data" :key="key">
                     <td class="col-name text-truncate" :title="value.name">{{ value.name }}</td>
                     <td class="col-actions">
                        <a
                           class="btn btn-primary btn-sm text-sm"
                           role="button"
                           @click="$refs.payoutListRef.editPayoutList(value)"
                        >
                           {{ $t('admin_page.payout_index.edit_button') }}
                        </a>
                     </td>
                     <td class="col-created">{{ formatDateToSlash(value.facility_setting_created_at) }}</td>
                     <td class="col-updated">{{ formatDateToSlash(value.payout_header_updated_at) }}</td>
                     <td class="col-payout">{{ formatDateToSlash(value.latest_payout_date) }}</td>
                     <td class="col-email">{{ formatDateTimeToSlash(value.latest_email_sent_at, true) || '—' }}</td> <!--converted as jst--> 
                  </tr>
               </tbody>
            </table>
         </div>
         <div class="col-sm-8">
            <pagination
               v-model="listOfFacilities.current_page"
               :per-page="listOfFacilities.per_page"
               :records="listOfFacilities.total"
               @paginate="paginate"
            ></pagination>
         </div>
      </div>

      <PayoutListModal ref="payoutListRef" :facilityid="listOfFacilities.facilityId" @closePayoutListModal="performSearch"/>
   </div>
</template>

<style lang="scss" scoped>
.table {
  table-layout: fixed; // ensure columns fit without horizontal scroll
}
.col-name { width: 28%; }
.col-actions { width: 7%; }
.col-created { width: 10%; }
.col-updated { width: 10%; }
.col-payout { width: 14%; }
.col-email { width: 15%; }

// Avoid horizontal scrolling by enabling wrapping and truncation where appropriate
.table th, .table td {
  white-space: nowrap;
}
.text-truncate {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

// If the container previously forced horizontal scroll, remove it
.table-responsive {
  overflow-x: visible !important;
}
</style>